"use client";

import { CreateMemory } from './CreateMemory';

// For backward compatibility
export const DailyDump = CreateMemory;
export { CreateMemory }; 